module.exports = __webpack_public_path__ + "static/media/learn02.58d46860.jpg";